import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./valuation-block-factor-adjustments.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./valuation-block-factor-adjustments.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ValuationBlockFactorAdjustmentConfigHeadingLookup } from "./shared/enums/pv-valuation-block-factor-adjustments.enum";
import { AppControllerService } from "../../../../../app-controller.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertType } from "../../../../../shared/models/alert";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AddValuationBlockFactorAdjustmentsService } from "./shared/services/add-valuation-block-factor-adjustments.service";
let ValuationBlockFactorAdjustmentsComponent = class ValuationBlockFactorAdjustmentsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    changeDetectorRef;
    addValuationBlockFactorAdjustmentService;
    viewApplicationService;
    appControllerService;
    modalService;
    dataSource = new BehaviorSubject([]);
    selectedFactorAdjustmentsInTable;
    tableMapper;
    addLabel = SharedConstants.ADD_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    deleteLabel = SharedConstants.DELETE_LABEL;
    valuationBlockId;
    getPropertyValuationValuationBlockFactorAdjustmentsSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, changeDetectorRef, addValuationBlockFactorAdjustmentService, viewApplicationService, appControllerService, modalService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.changeDetectorRef = changeDetectorRef;
        this.addValuationBlockFactorAdjustmentService = addValuationBlockFactorAdjustmentService;
        this.viewApplicationService = viewApplicationService;
        this.appControllerService = appControllerService;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initializeColumnToObjectMapping();
    }
    ngAfterViewInit() {
        this.getValuationBlockId();
    }
    arrayReturned(array) {
        this.selectedFactorAdjustmentsInTable = array;
    }
    handleRouteChange() {
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = ValuationBlockFactorAdjustmentConfigHeadingLookup;
    }
    getValuationBlockId() {
        const params = {
            $select: `id`,
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID} and deleted eq false`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params).pipe(map((response) => {
            return response.value;
        }))
            .subscribe({
            next: (valuationRunId) => {
                this.setValuationBlockId(valuationRunId?.[0]?.id);
                if (this.valuationBlockId) {
                    this.getPropertyValuationValuationBlockFactorAdjustments();
                }
                else {
                    this.appControllerService.showMessage("The ID of the current valuation block could not be found, please contact your system administrator", AlertType.Error);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage("valuation block ID", error, CRUDOperation.Get);
            }
        });
    }
    setValuationBlockId(valuationRunId) {
        this.valuationBlockId = valuationRunId;
    }
    getPropertyValuationValuationBlockFactorAdjustments() {
        const params = {
            $filter: `valuationBlockId eq ${this.valuationBlockId}`,
        };
        this.getPropertyValuationValuationBlockFactorAdjustmentsSubscription = this.addValuationBlockFactorAdjustmentService.getPropertyValuationValuationBlockFactorAdjustments(params).subscribe({
            next: (addValuationBlockFactorAdjustments) => {
                this.dataSource.next(addValuationBlockFactorAdjustments);
                this.changeDetectorRef.detectChanges();
            }, error: err => {
                this.appControllerService.handleServerErrorMessage("valuation block factor adjustments", err, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ChangeDetectorRef },
        { type: AddValuationBlockFactorAdjustmentsService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: NgbModal }
    ];
};
ValuationBlockFactorAdjustmentsComponent = __decorate([
    Component({
        selector: "app-valuation-block-factor-adjustments",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ValuationBlockFactorAdjustmentsComponent);
export { ValuationBlockFactorAdjustmentsComponent };
